import React from 'react';
import { Form, Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FormDropdown = ({
  label,
  icon,
  value,
  options,
  onSelect,
  className = '',
  iconAlt,
  toggleClassName = 'header-menu-dropdown-toggle mb-3',
  menuClassName = '',
  itemClassName = ''
}) => (
  <Form.Group className={`mb-2 d-flex align-items-center justify-content-between ${className}`}>
    {label && (
      <Form.Label className="me-2">
        {icon && <img className="label-icon" src={icon} alt={iconAlt || label} />}
        {label}
      </Form.Label>
    )}
    <Dropdown onSelect={onSelect}>
      <Dropdown.Toggle 
        id={`dropdown-${label?.toLowerCase().replace(/\s+/g, '-') || 'custom'}`} 
        className={toggleClassName}
      >
        {value}
      </Dropdown.Toggle>
      <Dropdown.Menu className={menuClassName}>
        {options.map((option) => (
          <Dropdown.Item 
            key={option.value || option} 
            eventKey={option.value || option}
            className={itemClassName}
          >
            {option.label || option}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </Form.Group>
);

FormDropdown.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    ])
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  iconAlt: PropTypes.string,
  toggleClassName: PropTypes.string,
  menuClassName: PropTypes.string,
  itemClassName: PropTypes.string
};

export default FormDropdown;